// PascalCase = convention Jetpack Compose officielle pour toute fonction @Composable, patron déjà
// suivi par tout le design system (StatusBadge, FruxButton...) et par cet écran depuis sa création
// (#164) ; ktlint(standard:function-naming) ne le sait que sur les fichiers dans le ratchet (#206),
// d'où la suppression fichier plutôt qu'un renommage qui romprait la convention Compose partout ici.
package fr.frux.feature.harvestdetail

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.CalendarMonth
import androidx.compose.material.icons.outlined.Check
import androidx.compose.material.icons.outlined.EventBusy
import androidx.compose.material.icons.outlined.Groups
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Icon
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.components.EmptyState
import fr.frux.core.designsystem.components.ErrorState
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxButtonStyle
import fr.frux.core.designsystem.components.FruxCard
import fr.frux.core.designsystem.components.FruxTopBar
import fr.frux.core.designsystem.components.InitialsAvatar
import fr.frux.core.designsystem.components.LoadingState
import fr.frux.core.designsystem.components.SnackbarMessageEffect
import fr.frux.core.designsystem.components.UserModerationMessage
import fr.frux.core.designsystem.components.message
import fr.frux.core.designsystem.error.userMessage
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.core.designsystem.theme.FruxStatus
import fr.frux.core.designsystem.theme.fruxColors
import fr.frux.feature.harvestdetail.resources.Res
import fr.frux.feature.harvestdetail.resources.harvestdetail_back
import fr.frux.feature.harvestdetail.resources.harvestdetail_complete_chip
import fr.frux.feature.harvestdetail.resources.harvestdetail_confirm
import fr.frux.feature.harvestdetail.resources.harvestdetail_dialog_cancel_message
import fr.frux.feature.harvestdetail.resources.harvestdetail_dialog_cancel_title
import fr.frux.feature.harvestdetail.resources.harvestdetail_dialog_complete_message
import fr.frux.feature.harvestdetail.resources.harvestdetail_dialog_complete_title
import fr.frux.feature.harvestdetail.resources.harvestdetail_full_notice
import fr.frux.feature.harvestdetail.resources.harvestdetail_join_cta
import fr.frux.feature.harvestdetail.resources.harvestdetail_leave_cta
import fr.frux.feature.harvestdetail.resources.harvestdetail_login_cta
import fr.frux.feature.harvestdetail.resources.harvestdetail_login_prompt_join
import fr.frux.feature.harvestdetail.resources.harvestdetail_login_prompt_leave
import fr.frux.feature.harvestdetail.resources.harvestdetail_login_prompt_moderate
import fr.frux.feature.harvestdetail.resources.harvestdetail_more_actions
import fr.frux.feature.harvestdetail.resources.harvestdetail_not_found_message
import fr.frux.feature.harvestdetail.resources.harvestdetail_not_found_title
import fr.frux.feature.harvestdetail.resources.harvestdetail_organized_by
import fr.frux.feature.harvestdetail.resources.harvestdetail_organizer_cancel
import fr.frux.feature.harvestdetail.resources.harvestdetail_organizer_complete
import fr.frux.feature.harvestdetail.resources.harvestdetail_organizer_start
import fr.frux.feature.harvestdetail.resources.harvestdetail_participants_over_capacity
import fr.frux.feature.harvestdetail.resources.harvestdetail_participants_overflow
import fr.frux.feature.harvestdetail.resources.harvestdetail_participants_plural
import fr.frux.feature.harvestdetail.resources.harvestdetail_participants_singular
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_cancelled
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_cancelled_notice
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_completed
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_completed_notice
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_expired
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_expired_notice
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_ongoing
import fr.frux.feature.harvestdetail.resources.harvestdetail_status_planned
import fr.frux.feature.harvestdetail.resources.harvestdetail_title
import fr.frux.feature.harvestdetail.resources.harvestdetail_title_fallback
import fr.frux.shared.domain.model.Harvest
import fr.frux.shared.domain.model.HarvestParticipant
import fr.frux.shared.domain.model.HarvestStatus
import fr.frux.shared.domain.model.Site
import fr.frux.shared.domain.model.Tree
import fr.frux.shared.domain.model.TreeStatus
import org.jetbrains.compose.resources.stringResource

/**
 * Harvest Detail Screen (#164).
 *
 * Pas d'action de partage : aucun deep link ne cible une récolte aujourd'hui, la simuler serait
 * mensonger. Le CTA bas d'écran bascule rejoindre/quitter selon la participation de l'utilisateur
 * courant, et s'efface pour l'organisateur (qui ne peut pas se retirer, cf. 403 ORGANIZER_CANNOT_LEAVE
 * côté backend) comme pour une récolte terminée/annulée.
 *
 * @param harvestId The ID of the harvest to display
 * @param onBack Callback when back button is clicked
 * @param onTreeClick Callback when the tree card is clicked (navigue vers la fiche arbre)
 * @param onSiteClick Idem pour une récolte de lieu (navigue vers la fiche du lieu, ADR 0035)
 * @param onLogin Callback quand l'invite de connexion (#264, anonyme sur rejoindre/quitter) est
 *   suivie depuis la snackbar
 */
@Composable
fun HarvestDetailScreen(
    harvestId: Long,
    onBack: () -> Unit,
    onTreeClick: (Long) -> Unit = {},
    onSiteClick: (Long) -> Unit = {},
    onLogin: () -> Unit = {},
    modifier: Modifier = Modifier,
    viewModel: HarvestDetailViewModel = rememberHarvestDetailViewModel(harvestId),
) {
    val state by viewModel.state.collectAsState()
    val snackbarHostState = remember { SnackbarHostState() }
    HarvestDetailSnackbarEffects(state, snackbarHostState, viewModel, onLogin, onBack)

    var showMenu by remember { mutableStateOf(false) }
    var showReportUserSheet by remember { mutableStateOf(false) }
    var showBlockDialog by remember { mutableStateOf(false) }

    Scaffold(
        modifier = modifier,
        topBar = {
            FruxTopBar(
                title = stringResource(Res.string.harvestdetail_title),
                onBack = onBack,
                actions = {
                    HarvestDetailActionsMenu(
                        canModerateOrganizer = state.canModerateOrganizer,
                        canReportDescription = state.canReportDescription,
                        organizerName = state.harvest?.createdByUsername.orEmpty(),
                        showMenu = showMenu,
                        onShowMenuChange = { showMenu = it },
                        onReportDescription = viewModel::onReportDescriptionClick,
                        onReportOrganizer = { if (viewModel.requestModeration()) showReportUserSheet = true },
                        onBlockOrganizer = { if (viewModel.requestModeration()) showBlockDialog = true },
                    )
                },
            )
        },
        snackbarHost = { SnackbarHost(snackbarHostState) },
        bottomBar = {
            state.harvest?.let { harvest ->
                HarvestDetailBottomBar(
                    harvest = harvest,
                    isParticipant = state.isParticipant,
                    isOrganizer = state.isOrganizer,
                    inFlight = state.joinLeaveInFlight,
                    statusChangeInFlight = state.statusChangeInFlight,
                    onJoinClick = viewModel::onJoinClick,
                    onLeaveClick = viewModel::onLeaveClick,
                    onStatusChangeClick = viewModel::onStatusChangeClick,
                )
            }
        },
        containerColor = MaterialTheme.colorScheme.background,
    ) { paddingValues ->
        HarvestDetailBody(state, paddingValues, onBack, onTreeClick, onSiteClick, viewModel::retry)
    }

    HarvestDetailModerationOverlays(
        organizerName = state.harvest?.createdByUsername.orEmpty(),
        showReportUserSheet = showReportUserSheet,
        showBlockDialog = showBlockDialog,
        onReportUserSheetDismiss = { showReportUserSheet = false },
        onReportOrganizer = { reason, details ->
            showReportUserSheet = false
            viewModel.onReportOrganizer(reason, details)
        },
        onBlockDialogDismiss = { showBlockDialog = false },
        onBlockOrganizerConfirmed = {
            showBlockDialog = false
            viewModel.onBlockOrganizerConfirmed()
        },
    )
}

/**
 * Snackbars de la fiche récolte : erreur d'action, invite de connexion (#264) et retour des
 * gestes de modération (ADR 0029, #515, masquer ramène ensuite à l'écran précédent). Extrait de
 * [HarvestDetailScreen] pour sa longueur (detekt LongMethod), même patron que
 * `TreeDetailSnackbarEffects`.
 */
@Composable
private fun HarvestDetailSnackbarEffects(
    state: HarvestDetailState,
    snackbarHostState: SnackbarHostState,
    viewModel: HarvestDetailViewModel,
    onLogin: () -> Unit,
    onBack: () -> Unit,
) {
    SnackbarMessageEffect(
        trigger = state.actionError,
        message = state.actionError?.userMessage(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeActionError() }

    SnackbarMessageEffect(
        trigger = state.loginPrompt,
        message = state.loginPrompt?.message(),
        snackbarHostState = snackbarHostState,
        actionLabel = stringResource(Res.string.harvestdetail_login_cta),
    ) { result ->
        viewModel.consumeLoginPrompt()
        if (result == SnackbarResult.ActionPerformed) onLogin()
    }

    // Masquer depuis la fiche ramène à l'écran précédent après l'annonce (ADR 0029).
    val leavesAfterMessage = state.moderationMessage is UserModerationMessage.Blocked
    SnackbarMessageEffect(
        trigger = state.moderationMessage,
        message = state.moderationMessage?.message(),
        snackbarHostState = snackbarHostState,
    ) {
        viewModel.consumeModerationMessage()
        if (leavesAfterMessage) onBack()
    }
}

/**
 * Contenu du `Scaffold` selon l'état de chargement de la récolte. Extrait de
 * [HarvestDetailScreen] pour sa longueur (detekt LongMethod).
 */
@Composable
private fun HarvestDetailBody(
    state: HarvestDetailState,
    paddingValues: PaddingValues,
    onBack: () -> Unit,
    onTreeClick: (Long) -> Unit,
    onSiteClick: (Long) -> Unit,
    onRetry: () -> Unit,
) {
    when {
        state.isLoading -> {
            LoadingState(Modifier.padding(paddingValues))
        }

        state.notFound -> {
            // Parcours nominal depuis #192 : la notification d'annulation survit à la
            // récolte supprimée avec son arbre — un état expliqué, pas une erreur (#312).
            EmptyState(
                icon = Icons.Outlined.EventBusy,
                title = stringResource(Res.string.harvestdetail_not_found_title),
                message = stringResource(Res.string.harvestdetail_not_found_message),
                ctaLabel = stringResource(Res.string.harvestdetail_back),
                onCta = onBack,
                modifier = Modifier.padding(paddingValues),
            )
        }

        state.error != null -> {
            ErrorState(
                message = state.error!!.userMessage(),
                onRetry = onRetry,
                modifier = Modifier.padding(paddingValues),
            )
        }

        else -> {
            state.harvest?.let { harvest ->
                HarvestDetailContent(
                    harvest = harvest,
                    tree = state.tree,
                    site = state.site,
                    onTreeClick = { harvest.treeId?.let(onTreeClick) },
                    onSiteClick = { harvest.siteId?.let(onSiteClick) },
                    modifier = Modifier.padding(paddingValues),
                )
            }
        }
    }
}

/** Action de cycle de vie en attente de confirmation (#226) — `null` = aucun dialogue ouvert. */
private enum class PendingStatusChange {
    Cancel,
    Complete,
}

@Composable
private fun HarvestStatusChangeDialog(
    pending: PendingStatusChange,
    onDismiss: () -> Unit,
    onConfirm: (HarvestStatus) -> Unit,
) {
    val (title, message, target) =
        when (pending) {
            PendingStatusChange.Cancel -> {
                Triple(
                    stringResource(Res.string.harvestdetail_dialog_cancel_title),
                    stringResource(Res.string.harvestdetail_dialog_cancel_message),
                    HarvestStatus.CANCELLED,
                )
            }

            PendingStatusChange.Complete -> {
                Triple(
                    stringResource(Res.string.harvestdetail_dialog_complete_title),
                    stringResource(Res.string.harvestdetail_dialog_complete_message),
                    HarvestStatus.COMPLETED,
                )
            }
        }
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(title) },
        text = { Text(message) },
        confirmButton = {
            TextButton(onClick = {
                onDismiss()
                onConfirm(target)
            }) {
                Text(stringResource(Res.string.harvestdetail_confirm))
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(stringResource(Res.string.harvestdetail_back))
            }
        },
    )
}

@Composable
private fun HarvestBottomBarContent(
    harvest: Harvest,
    isParticipant: Boolean,
    isOrganizer: Boolean,
    inFlight: Boolean,
    statusChangeInFlight: Boolean,
    onJoinClick: () -> Unit,
    onLeaveClick: () -> Unit,
    onStatusChangeClick: (HarvestStatus) -> Unit,
    onPendingChange: (PendingStatusChange) -> Unit,
) {
    when {
        !harvest.status.acceptsParticipants -> {
            Text(
                text =
                    if (harvest.status == HarvestStatus.COMPLETED) {
                        stringResource(Res.string.harvestdetail_status_completed_notice)
                    } else {
                        stringResource(Res.string.harvestdetail_status_cancelled_notice)
                    },
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }

        isOrganizer -> {
            OrganizerStatusActions(
                status = harvest.status,
                expired = harvest.expired,
                inFlight = statusChangeInFlight,
                onStartClick = { onStatusChangeClick(HarvestStatus.ONGOING) },
                onCompleteClick = { onPendingChange(PendingStatusChange.Complete) },
                onCancelClick = { onPendingChange(PendingStatusChange.Cancel) },
            )
        }

        isParticipant -> {
            FruxButton(
                text = stringResource(Res.string.harvestdetail_leave_cta),
                onClick = onLeaveClick,
                style = FruxButtonStyle.Tonal,
                icon = Icons.Outlined.Check,
                loading = inFlight,
                modifier = Modifier.fillMaxWidth(),
            )
        }

        // Passée (#435) : le serveur refuserait le join, on ne le propose pas. Testé après
        // l'organisateur (qui garde Terminer/Annuler pour faire le ménage) et le participant
        // (qui peut toujours quitter).
        harvest.expired -> {
            Text(
                text = stringResource(Res.string.harvestdetail_status_expired_notice),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }

        harvest.isFull -> {
            Text(
                text = stringResource(Res.string.harvestdetail_full_notice),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }

        else -> {
            FruxButton(
                text = stringResource(Res.string.harvestdetail_join_cta),
                onClick = onJoinClick,
                style = FruxButtonStyle.Filled,
                loading = inFlight,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}

@Composable
private fun HarvestDetailBottomBar(
    harvest: Harvest,
    isParticipant: Boolean,
    isOrganizer: Boolean,
    inFlight: Boolean,
    statusChangeInFlight: Boolean,
    onJoinClick: () -> Unit,
    onLeaveClick: () -> Unit,
    onStatusChangeClick: (HarvestStatus) -> Unit,
) {
    var pendingChange by remember { mutableStateOf<PendingStatusChange?>(null) }

    pendingChange?.let { pending ->
        HarvestStatusChangeDialog(
            pending = pending,
            onDismiss = { pendingChange = null },
            onConfirm = onStatusChangeClick,
        )
    }

    Surface(shadowElevation = 4.dp, color = MaterialTheme.colorScheme.background) {
        Column(
            modifier =
                Modifier
                    .fillMaxWidth()
                    .padding(FruxSpacing.md),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            HarvestBottomBarContent(
                harvest = harvest,
                isParticipant = isParticipant,
                isOrganizer = isOrganizer,
                inFlight = inFlight,
                statusChangeInFlight = statusChangeInFlight,
                onJoinClick = onJoinClick,
                onLeaveClick = onLeaveClick,
                onStatusChangeClick = onStatusChangeClick,
                onPendingChange = { pendingChange = it },
            )
        }
    }
}

/**
 * Actions de cycle de vie de l'organisateur (#226) : `PLANNED` propose Démarrer + Annuler (Annuler
 * seul une fois expirée, #601),
 * `ONGOING` propose Terminer + Annuler — les états terminaux sont déjà exclus par l'appelant
 * (`!harvest.status.acceptsParticipants` passe en premier dans le `when`).
 */
@Composable
private fun OrganizerStatusActions(
    status: HarvestStatus,
    expired: Boolean,
    inFlight: Boolean,
    onStartClick: () -> Unit,
    onCompleteClick: () -> Unit,
    onCancelClick: () -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(FruxSpacing.sm),
    ) {
        when (status) {
            // Passée (#601) : le serveur refuserait le démarrage, il ne reste qu'à annuler.
            HarvestStatus.PLANNED -> {
                if (!expired) {
                    FruxButton(
                        text = stringResource(Res.string.harvestdetail_organizer_start),
                        onClick = onStartClick,
                        style = FruxButtonStyle.Filled,
                        loading = inFlight,
                        modifier = Modifier.fillMaxWidth(),
                    )
                }
            }

            HarvestStatus.ONGOING -> {
                FruxButton(
                    text = stringResource(Res.string.harvestdetail_organizer_complete),
                    onClick = onCompleteClick,
                    style = FruxButtonStyle.Filled,
                    loading = inFlight,
                    modifier = Modifier.fillMaxWidth(),
                )
            }

            // Inatteignable : l'appelant filtre déjà !harvest.status.acceptsParticipants avant
            // d'entrer dans cette branche (états terminaux affichent un texte figé, cf. HarvestDetailBottomBar).
            HarvestStatus.COMPLETED, HarvestStatus.CANCELLED -> {}
        }
        FruxButton(
            text = stringResource(Res.string.harvestdetail_organizer_cancel),
            onClick = onCancelClick,
            style = FruxButtonStyle.Outline,
            enabled = !inFlight,
            modifier = Modifier.fillMaxWidth(),
        )
    }
}

@Composable
private fun HarvestDetailContent(
    harvest: Harvest,
    tree: Tree?,
    site: Site?,
    onTreeClick: () -> Unit,
    onSiteClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    LazyColumn(modifier = modifier.fillMaxWidth()) {
        item {
            Column(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .padding(FruxSpacing.md),
            ) {
                Text(
                    text = harvestTitleText(harvest),
                    style = MaterialTheme.typography.headlineLarge,
                )
                // Pseudo réel de l'organisateur (#206), jamais un id maquillé en nom : absent tant
                // que le backend ne l'a pas renseigné (compte anonymisé compris, cf. patron Tree).
                harvest.createdByUsername?.let { organizerUsername ->
                    Text(
                        text = stringResource(Res.string.harvestdetail_organized_by, organizerUsername),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                Spacer(Modifier.height(FruxSpacing.sm))
                Row(verticalAlignment = Alignment.CenterVertically) {
                    HarvestStatusChip(status = harvest.status, expired = harvest.expired)
                    if (harvest.isFull && !harvest.expired) {
                        Spacer(Modifier.width(FruxSpacing.xs))
                        CompleteChip()
                    }
                }
                Spacer(Modifier.height(FruxSpacing.md))

                if (harvest.hostedByOwner) {
                    HarvestSiteCard(harvest = harvest)
                    Spacer(Modifier.height(FruxSpacing.md))
                }

                FruxCard(modifier = Modifier.fillMaxWidth()) {
                    FactRow(
                        icon = Icons.Outlined.CalendarMonth,
                        text = formatHarvestDateTime(harvest.scheduledDate),
                    )
                    Spacer(Modifier.height(FruxSpacing.sm))
                    HarvestTargetFact(harvest, tree, site, onTreeClick, onSiteClick)
                }

                Spacer(Modifier.height(FruxSpacing.md))

                FruxCard(modifier = Modifier.fillMaxWidth()) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(
                            imageVector = Icons.Outlined.Groups,
                            contentDescription = null,
                            tint = MaterialTheme.colorScheme.primary,
                        )
                        Spacer(Modifier.width(FruxSpacing.sm))
                        Text(
                            text =
                                harvest.maxParticipants?.let { max ->
                                    stringResource(
                                        Res.string.harvestdetail_participants_over_capacity,
                                        harvest.participantsCount,
                                        max,
                                    )
                                } ?: cueilleursLabel(harvest.participantsCount),
                            style = MaterialTheme.typography.titleMedium,
                        )
                    }
                    val maxParticipants = harvest.maxParticipants
                    if (maxParticipants != null) {
                        Spacer(Modifier.height(FruxSpacing.sm))
                        LinearProgressIndicator(
                            progress = { harvest.participantsCount.toFloat() / maxParticipants },
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    Spacer(Modifier.height(FruxSpacing.sm))
                    CueilleursRow(
                        participants = harvest.organizerFirstParticipants(),
                        fallbackCount = harvest.participantsCount,
                    )
                }

                // Pas de section « Description » distincte : le DTO ne porte qu'un seul champ texte
                // libre, déjà utilisé comme titre ci-dessus (description si présente, sinon date de
                // repli). Le répéter en dessous serait un doublon exact du même texte, pas une
                // information supplémentaire.

                Spacer(Modifier.height(FruxSpacing.xl))
            }
        }
    }
}

@Composable
internal fun FactRow(
    icon: androidx.compose.ui.graphics.vector.ImageVector,
    text: String,
    onClick: (() -> Unit)? = null,
) {
    Row(
        modifier =
            Modifier
                .fillMaxWidth()
                .let { if (onClick != null) it.clickable(onClick = onClick) else it },
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Icon(
            imageVector = icon,
            contentDescription = null,
            tint = MaterialTheme.colorScheme.primary,
        )
        Spacer(Modifier.width(FruxSpacing.sm))
        Text(
            text = text,
            style = MaterialTheme.typography.bodyMedium,
        )
    }
}

/**
 * Organisateur en tête (#206), quel que soit l'ordre renvoyé par le backend : c'est une décision
 * d'affichage, pas un contrat serveur. `partition` est stable, donc l'ordre relatif des autres
 * participants (pertinent seulement s'il y en a plusieurs) est préservé.
 */
internal fun Harvest.organizerFirstParticipants(): List<HarvestParticipant> {
    val (organizer, others) = participantsDetails.partition { it.id == createdBy }
    return organizer + others
}

/**
 * Avatars à initiales (#206), fond alterné primaryContainer/tertiaryContainer par position ; un
 * participant sans pseudo (compte anonymisé) retombe sur l'icône Person générique, jamais une
 * initiale inventée. Repli sur [fallbackCount] icônes génériques quand [participants] est vide
 * (backend pas encore enrichi, ou fixture de test qui ne construit pas participantsDetails) — ne
 * jamais afficher zéro avatar alors que le compteur au-dessus annonce des cueilleurs.
 */
@Composable
private fun CueilleursRow(
    participants: List<HarvestParticipant>,
    fallbackCount: Int,
) {
    val maxShown = 6
    if (participants.isEmpty()) {
        LegacyCueilleursRow(count = fallbackCount, maxShown = maxShown)
        return
    }
    Row(verticalAlignment = Alignment.CenterVertically) {
        participants.take(maxShown).forEachIndexed { index, participant ->
            InitialsAvatar(
                username = participant.username,
                size = 28.dp,
                containerColor =
                    if (index % 2 == 0) {
                        MaterialTheme.colorScheme.primaryContainer
                    } else {
                        MaterialTheme.colorScheme.tertiaryContainer
                    },
                contentColor =
                    if (index % 2 == 0) {
                        MaterialTheme.colorScheme.onPrimaryContainer
                    } else {
                        MaterialTheme.colorScheme.onTertiaryContainer
                    },
            )
            if (index != participants.take(maxShown).lastIndex) {
                Spacer(Modifier.width(FruxSpacing.xs))
            }
        }
        if (participants.size > maxShown) {
            Spacer(Modifier.width(FruxSpacing.xs))
            Text(
                text = stringResource(Res.string.harvestdetail_participants_overflow, participants.size - maxShown),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}

/** Repli historique (avant #206) : icône générique par tête, quand aucun détail n'est disponible. */
@Composable
private fun LegacyCueilleursRow(
    count: Int,
    maxShown: Int,
) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        repeat(count.coerceAtMost(maxShown)) {
            Icon(
                imageVector = Icons.Outlined.Person,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.size(20.dp),
            )
        }
        if (count > maxShown) {
            Spacer(Modifier.width(FruxSpacing.xs))
            Text(
                text = stringResource(Res.string.harvestdetail_participants_overflow, count - maxShown),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}

/**
 * Titre de l'écran : description libre si renseignée, sinon repli sur la date planifiée (#194).
 * Extrait de HarvestDetailContent pour rester sous le seuil detekt LongMethod, pas seulement pour
 * la longueur de ligne.
 */
@Composable
private fun harvestTitleText(harvest: Harvest): String =
    harvest.description?.takeIf { it.isNotBlank() }
        ?: stringResource(Res.string.harvestdetail_title_fallback, formatHarvestDateTime(harvest.scheduledDate))

@Composable
private fun cueilleursLabel(count: Int): String =
    if (count <= 1) {
        stringResource(Res.string.harvestdetail_participants_singular, count)
    } else {
        stringResource(Res.string.harvestdetail_participants_plural, count)
    }

/**
 * Badge de statut de récolte, même habillage visuel que `StatusBadge` (pilule teintée) : pas de
 * composant partagé côté design system car `StatusBadge` est typé sur `FruxStatus`, la
 * disponibilité d'un arbre — une sémantique différente de celle d'une récolte.
 */
@Composable
private fun HarvestStatusChip(
    status: HarvestStatus,
    expired: Boolean,
    modifier: Modifier = Modifier,
) {
    // « Passée » (#435) remplace « Planifiée »/« En cours » : le statut n'a pas changé en base,
    // seule la date est dépassée. Les états terminaux ne sont jamais expirés.
    val color =
        when {
            expired -> MaterialTheme.fruxColors.statusPicked
            status == HarvestStatus.PLANNED -> MaterialTheme.fruxColors.statusFlowering
            status == HarvestStatus.ONGOING -> MaterialTheme.fruxColors.statusAvailable
            status == HarvestStatus.COMPLETED -> MaterialTheme.fruxColors.statusPicked
            else -> MaterialTheme.fruxColors.statusUnavailable
        }
    val label =
        when {
            expired -> stringResource(Res.string.harvestdetail_status_expired)
            status == HarvestStatus.PLANNED -> stringResource(Res.string.harvestdetail_status_planned)
            status == HarvestStatus.ONGOING -> stringResource(Res.string.harvestdetail_status_ongoing)
            status == HarvestStatus.COMPLETED -> stringResource(Res.string.harvestdetail_status_completed)
            else -> stringResource(Res.string.harvestdetail_status_cancelled)
        }
    Text(
        text = label,
        style = MaterialTheme.typography.labelMedium,
        color = color,
        modifier =
            modifier
                .clip(RoundedCornerShape(50))
                .background(color.copy(alpha = 0.14f))
                .padding(horizontal = 10.dp, vertical = 4.dp),
    )
}

/** Pilule « Complet » à côté du statut, même habillage que [HarvestStatusChip] (#194-maxParticipants). */
@Composable
private fun CompleteChip(modifier: Modifier = Modifier) {
    val color = MaterialTheme.fruxColors.statusUnavailable
    Text(
        text = stringResource(Res.string.harvestdetail_complete_chip),
        style = MaterialTheme.typography.labelMedium,
        color = color,
        modifier =
            modifier
                .clip(RoundedCornerShape(50))
                .background(color.copy(alpha = 0.14f))
                .padding(horizontal = 10.dp, vertical = 4.dp),
    )
}

/** Libellé de l'invite de connexion pour le geste refusé (#264). */
@Composable
private fun HarvestLoginPrompt.message(): String =
    when (this) {
        HarvestLoginPrompt.Join -> stringResource(Res.string.harvestdetail_login_prompt_join)
        HarvestLoginPrompt.Leave -> stringResource(Res.string.harvestdetail_login_prompt_leave)
        HarvestLoginPrompt.Moderate -> stringResource(Res.string.harvestdetail_login_prompt_moderate)
    }
